import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiConversationTopic } from '@wix/da-papi-types';
import UserLink from '@wix/da-shared-react/pkg/User/Link';
import s from './Commentable.scss';

export interface Props {
  topic: PapiConversationTopic;
}

// aka Group forum/announcement commentable...
export const ConversationTopic: React.FC<Props> = ({ topic }) => {
  const { t } = useTranslation();
  const { title, group, url } = topic;

  return (
    <h1 className={s['text']}>
      {t('commentable.title.conversationTopic', {
        postProcess: ['reactPostprocessor', 'featureBrancher'],
        topic: (
          <a className={s['link']} href={url}>
            {title}
          </a>
        ),
        group: <UserLink className={s['link']} user={group} />,
      })}
    </h1>
  );
};
ConversationTopic.displayName = 'ConversationTopic';

export default ConversationTopic;
